exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-main-navigation{position:absolute;top:0;left:0;z-index:50;display:inline-block;vertical-align:top;width:300px;height:100%;background-color:#fff;transform:translateX(-100%);transition:transform .3s ease-in-out}adp-main-navigation.opened{box-shadow:0 2px 4px 0 rgba(0,0,0,.1);transform:translateX(0);transition:transform .3s ease-in-out}adp-main-navigation .show-mobile{display:none}adp-main-navigation .nav-section:first-of-type h4{margin-top:0;border-top:none}adp-main-navigation .nav-section h4{margin:25px 20px 10px;padding-top:25px;border-top:1px solid #e4e4e4;color:#6a6a6a;font-size:12px}@media only screen and (max-width:779px){adp-main-navigation .show-mobile{display:block}adp-main-navigation .nav-section h4{margin:20px 30px 5px;padding-top:25px}adp-main-navigation .nav-section .vertical-nav{font-size:18px}adp-main-navigation .nav-section .vertical-nav li span{padding-left:40px;padding-right:40px}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpMainNavigation/adpMainNavigation.less
// module id = 606
// module chunks = 0